import {
  GridColDef,
  GridColumns,
  GridRenderCellParams,
  GridRowParams
} from '@mui/x-data-grid-premium';
import {
  dateFilterOperators,
  filterOperators,
  singleSelectFilterOperators
} from '../../../../constants';
import { useTranslation } from 'react-i18next';
import { baseCell } from '../cells/base-cell';
import SectionTitle from 'components/common/SectionTitle';
import { Link } from 'react-router-dom';
import { MODELS_MAPS } from 'features/versions';
import ConfirmationGridRestoreDialog from 'components/helpers/ConfirmationGridRestore';
import toast from 'features/toast';
import { logService } from 'services/api/LogService';

export function DeletedVersionsColumns(): GridColDef[] {
  const { t } = useTranslation();
  const columns: GridColumns = [
    {
      field: 'object_id',
      headerName: t(`global.object`),
      width: 200,
      renderCell: (params) => {
        return (
          <Link
            to={`/tenant/versions/${params.row.model_name}/${params.row.object_id}`}
            style={{ textDecoration: 'none', color: '#1976d2' }}>
            <SectionTitle>{params.row.object_id}</SectionTitle>
          </Link>
        );
      }
    },
    {
      field: 'object_value',
      headerName: t(`global.value`),
      filterOperators,
      width: 200,
      renderCell: baseCell
    },
    {
      field: 'model_name',
      headerName: t(`global.model`),
      type: 'singleSelect',
      valueOptions: Object.entries(MODELS_MAPS).map(([value, meta]) => ({
        value,
        label: meta?.label || value
      })),
      filterOperators: singleSelectFilterOperators,
      width: 200,
      renderCell: (params) => {
        const modelKey = params.value;
        return MODELS_MAPS[modelKey]?.label || modelKey; // fallback se non trova la label
      }
    },
    {
      field: 'timestamp',
      headerName: t(`global.date`),
      filterOperators: dateFilterOperators,
      width: 200,
      renderCell: (params: GridRenderCellParams) => {
        const date = new Date(params.value as string);
        return date.toLocaleString('default', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit'
        });
      }
    },
    {
      field: 'actor_name',
      headerName: t(`global.user`),
      filterOperators,
      width: 200,
      renderCell: (params) => {
        const value = params.value;
        return value == null ? 'SYSTEM' : baseCell(params);
      }
    },
    {
      field: 'actions',
      type: 'actions',
      headerName: t(`global.actions`),
      width: 120,
      sortable: false,
      filterable: false,
      getActions: (params: GridRowParams) => {
        return [
          <ConfirmationGridRestoreDialog
            key={1}
            label="Ripristina"
            onConfirm={async () => {
              await logService.restoreDeletedObject(params.row.id);
              toast.success('Ripristino eseguito');
            }}
          />
        ];
      }
    }
  ];
  return columns;
}
